import React from 'react';

import { showDateNoTimeExtended } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';
import Visibilities from '@components/Gui/Visibilities';

import { EventDetailsWrapper } from '../EventDrawerUi/EventUI';
import { taskHasDifferentDescriptions } from './TaskUtils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TaskDetails = ({ taskData }) => {
    const columns = [];
    columns.push({
        content: (
            <div className="is-icon">
                <NwIcon icon={byPrefixAndName.fasl['tasks']} />
            </div>
        ),
        isBorder: true,
    });
    if (taskData.Date) {
        columns.push({
            content: (
                <div>
                    {taskData.PrivacyLevelName !== 'Public' && (
                        <div style={{ marginBottom: '.5rem' }}>
                            <NwTag type="primary">Personal</NwTag>
                        </div>
                    )}
                    {taskData.RemindDate && (
                        <>
                            <div className="is-label">don't show before</div>
                            <div className="is-content">{showDateNoTimeExtended(taskData.RemindDate)}</div>
                        </>
                    )}
                    {taskData.Date && (
                        <>
                            <div className="is-label">due date</div>
                            <div className="is-content">{showDateNoTimeExtended(taskData.Date)}</div>
                        </>
                    )}
                </div>
            ),
            isBorder: false,
        });
    }

    return (
        <EventDetailsWrapper>
            <ResponsiveFlexContainer leftMinWidth={140} columns={columns} />
            {!taskHasDifferentDescriptions(taskData) && (
                <ResponsiveFlexContainer
                    leftMinWidth={140}
                    columns={[
                        {
                            content: <div className="is-label">DESCRIPTION</div>,
                            isBorder: true,
                        },
                        {
                            content: <div className="is-content">{taskData.Description}</div>,
                        },
                    ]}
                />
            )}
            <ResponsiveFlexContainer
                leftMinWidth={140}
                columns={[
                    {
                        content: <div className="is-label">Visibility Areas</div>,
                        isBorder: true,
                    },
                    {
                        content: <Visibilities hideLabel visibilities={taskData.Visibility.Areas} />,
                    },
                ]}
            />
        </EventDetailsWrapper>
    );
};

export default TaskDetails;
